const Logo = {
  init() {
    $(".site-logo").removeClass("out");

    $(".site-logo").each(function () {
      const currEl = $(this);
      Logo.animate(currEl);
    });
  },

  animate(siteLogo) {
    clearTimeout(siteLogo.timeout);

    // is last
    if (siteLogo.find(".site-logo__runes-item--main.visible").length) {
      siteLogo
        .find(".site-logo__runes-item--main.visible")
        .removeClass("visible");
      siteLogo.find(".site-logo__runes-item").first().addClass("visible");
    } else {
      let activeEl = siteLogo.find(".site-logo__runes-item.visible");
      if (!activeEl.length) {
        activeEl = siteLogo.find(".site-logo__runes-item").first();
      }

      activeEl.removeClass("visible");
      activeEl.next().addClass("visible");
    }

    siteLogo.timeout = setTimeout(() => {
      Logo.animate(siteLogo);
    }, 2000);
  },
};

export default Logo;
